import { Footer } from '@/components/Footer';
import { Navbar } from '@/components/Navbar';

export default function PrivacyPolicyPage() {
  return (
    <div className="flex min-h-screen flex-col bg-neutral-50 text-neutral-800">
      <Navbar />

      <main className="mx-auto w-full max-w-4xl flex-1 px-4 pb-12 pt-28 sm:px-6 lg:px-8">
        <div className="rounded-lg bg-white p-8 shadow-sm">
          <h1 className="mb-4 font-heading text-3xl font-bold text-neutral-900">
            Politică de confidențialitate – SolomonQ
          </h1>

          <p className="mb-6 text-sm text-neutral-600">
            <strong>Ultima actualizare:</strong> 16 ianuarie 2026
            <br />
            <strong>Operator:</strong> Platforma „SolomonQ” este operată de
            Operatorii Platformei („Operatorii”). Pentru solicitări privind
            datele cu caracter personal ne puteți contacta la{' '}
            <a
              href="mailto:solomonq.team@gmail.com"
              className="text-primary hover:underline">
              solomonq.team@gmail.com
            </a>
            .
            <br />
            Prezenta politică descrie modul în care prelucrăm datele cu caracter
            personal în legătură cu utilizarea Platformei.
          </p>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              1) Ce date prelucrăm
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              În funcție de modul în care utilizați Platforma, putem prelucra:
              <br />
              <br />
              <strong>Date de cont:</strong> adresă de email, date de
              autentificare (de ex. parolă stocată în format securizat/hashed),
              identificatori de cont și setări.
              <br />
              <br />
              <strong>Date privind alertele:</strong> reguli/criterii ale
              alertelor, preferințe și setări de notificare.
              <br />
              <br />
              <strong>Date tehnice și de utilizare:</strong> informații tehnice
              despre utilizarea Platformei (de ex. tipul browserului), necesare
              pentru funcționare, securitate și îmbunătățirea serviciului.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              2) Scopuri și temeiuri legale
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Prelucrăm datele în următoarele scopuri:
              <br />
              <br />
              <strong>
                Furnizarea Platformei și administrarea contului
              </strong>{' '}
              (art. 6(1)(b) GDPR – executarea contractului).
              <br />
              <br />
              <strong>Transmiterea alertelor configurate</strong> (art. 6(1)(b)
              GDPR).
              <br />
              <br />
              <strong>Securitate, prevenirea abuzului și depanare</strong> (art.
              6(1)(f) GDPR – interes legitim).
              <br />
              <br />
              <strong>Analitice și îmbunătățirea produsului</strong> (art.
              6(1)(f) GDPR – interes legitim), în măsura permisă de legislația
              aplicabilă.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              3) Cookie-uri strict necesare
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Platforma utilizează cookie-uri strict necesare pentru
              funcționarea de bază a serviciului, cum ar fi menținerea sesiunii
              de autentificare. Nu folosim cookie-uri de marketing sau
              publicitate.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              4) Cui divulgăm datele (împuterniciți)
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Nu vindem și nu închiriem datele dumneavoastră. Putem apela la
              furnizori terți (persoane împuternicite) pentru servicii precum
              găzduire, infrastructură, livrarea emailurilor (alerte) și
              analitice. Aceștia prelucrează datele exclusiv în baza
              instrucțiunilor noastre, numai în măsura necesară prestării
              serviciilor și fără a le utiliza în scopuri proprii.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              5) Transferuri în afara SEE
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Dacă un furnizor procesează date în afara Spațiului Economic
              European (SEE), utilizăm garanții adecvate (de ex. clauze
              contractuale standard) și, după caz, măsuri suplimentare.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              6) Cât timp păstrăm datele
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Păstrăm datele cu caracter personal doar pe perioada necesară
              îndeplinirii scopurilor descrise mai sus:
              <br />
              <br />
              <strong>Date de cont și alerte:</strong> pe durata existenței
              contului (sau până la ștergere, unde este aplicabil).
              <br />
              <br />
              Dacă doriți ștergerea datelor, ne puteți scrie la{' '}
              <a
                href="mailto:solomonq.team@gmail.com"
                className="text-primary hover:underline">
                solomonq.team@gmail.com
              </a>
              .
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              7) Drepturile dumneavoastră
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              În condițiile GDPR, aveți dreptul la acces, rectificare, ștergere,
              restricționare, opoziție și portabilitate. Pentru exercitarea
              drepturilor, ne puteți contacta la adresa{' '}
              <a
                href="mailto:solomonq.team@gmail.com"
                className="text-primary hover:underline">
                solomonq.team@gmail.com
              </a>
              .
              <br />
              <br />
              De asemenea, aveți dreptul de a depune o plângere la autoritatea
              de supraveghere din România (ANSPDCP).
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              8) Securitate
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Implementăm și menținem măsuri tehnice și organizatorice adecvate
              pentru a proteja datele cu caracter personal, inclusiv control al
              accesului (doar persoane autorizate, conform principiului
              „need-to-know”), monitorizare și jurnalizare pentru detectarea
              incidentelor și criptare în tranzit. Cu toate acestea, niciun
              sistem nu poate garanta securitate 100%.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              9) Minori
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Platforma nu este destinată minorilor sub 18 ani și nu prelucrăm
              în mod intenționat date cu caracter personal ale acestora.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              10) Contact
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Pentru întrebări sau solicitări privind datele dumneavoastră, vă
              rugăm să ne contactați la{' '}
              <a
                href="mailto:solomonq.team@gmail.com"
                className="text-primary hover:underline">
                solomonq.team@gmail.com
              </a>
              .
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
